import React from 'react';


const Testeroute: React.FC = () => {
    return(
        <div>
            <h1>teste de pagina</h1>
        </div>
    )
}

export default Testeroute;